// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { FONTWEIGHT, COLORS } from "../../utils/styles"

const container = css`
  font-weight: ${FONTWEIGHT.MEDIUM};
  color: ${COLORS.C3E51B5};
  cursor: pointer;
  text-decoration: none;
  word-wrap: break-word;
`

export { container }
